import { API_BASE_URL } from './client';
import { consumeChatNdjsonStream } from './consumeNdjsonStream';

export { consumeChatNdjsonStream };

/**
 * Subscribe to live SSE updates for a chat session.
 */
export function subscribeLiveSession(sessionId, token, handlers = {}) {
  const { onUiPatch, onProactiveMessage, onError } = handlers;
  const url = `${API_BASE_URL}/chat/live/${encodeURIComponent(sessionId)}`;
  const controller = new AbortController();

  fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
    signal: controller.signal,
  }).then(async (res) => {
    if (!res.ok || !res.body) {
      onError?.({ message: 'Live channel failed' });
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = '';
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const lines = buf.split('\n');
      buf = lines.pop() ?? '';
      for (const line of lines) {
        if (!line.startsWith('data:')) continue;
        const data = line.slice(5).trim();
        if (!data) continue;
        try {
          const event = JSON.parse(data);
          if (event.type === 'ui_patch') onUiPatch?.(event.patch);
          if (event.type === 'proactive_message') onProactiveMessage?.(event.content);
        } catch {
          /* ignore */
        }
      }
    }
  }).catch((e) => {
    if (e.name !== 'AbortError') onError?.(e);
  });

  return () => controller.abort();
}
